// Libs
import classNames from 'classnames/bind';
import { Grid2 } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseUploadDocument, BaseUploadImage } from '~/components/common';
// Others
import { IBaseFile } from '~/utils/interface/common';
import { IFormInventory } from '~/utils/interface/inventory';
// Styles, images, icons
import styles from './FileInventoryForm.module.scss';

type Props = {
  onRemoveFile?: (id: string) => void;
};

const cx = classNames.bind(styles);

const FileInventoryForm = (props: Props) => {
  //#region Destructuring Props
  const { onRemoveFile } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IFormInventory>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleRemoveFile = (file: IBaseFile) => {
    if (!file.id) return;

    onRemoveFile?.(file.id);
  };
  //#endregion Handle Function

  return (
    <Grid2 id='fileInventoryFormComponent' columnSpacing={'26px'} container>
      <Grid2 size={6}>
        <Controller
          control={control}
          name={'inventoryImage'}
          render={({ field: { onChange, value } }) => {
            return (
              <BaseUploadImage
                label={t('inventory_form_title_product_photos')}
                uploadedFiles={value}
                onChange={(files: IBaseFile[]) => onChange(files)}
                onRemove={handleRemoveFile}
                errorMessage={errors.inventoryImage?.message}
              />
            );
          }}
        />
      </Grid2>

      <Grid2 size={6}>
        <Controller
          control={control}
          name={'inventoryFile'}
          render={({ field: { onChange, value } }) => {
            return (
              <BaseUploadDocument
                label={t('inventory_form_title_info_sheets')}
                uploadedFiles={value}
                onChange={(files: IBaseFile[]) => onChange(files)}
                onRemove={handleRemoveFile}
                errorMessage={errors.inventoryFile?.message}
              />
            );
          }}
        />
      </Grid2>
    </Grid2>
  );
};

export default FileInventoryForm;
